import axios from '../axios-on-rails';

export default class CtAnnouncement {
  fetch() {
    axios.get(Routes.fetch_ct_announcements_path(gon.locale))
      .then(response => {
        let ct_announcement = response['data']['ct_announcement'];
        if (ct_announcement != null) {
          $('#CtAnnouncementModal').after("<div class='modal-backdrop'></div>");
          $('.modal-backdrop').addClass('show');
          $('#CtAnnouncementModal').show();
          $('#CtAnnouncementModal').addClass('show fade');
          $('body').addClass('modal-open');
          $('#CtAnnouncementModalLongTitle').html(response['data']['ct_announcement']['subject']);
          $('#CtAnnouncementModal .modal-body').html(response['data']['ct_announcement']['body'].replace(/\n/g, '<br>'));
          $('#CtAnnouncementModal .modal-footer button').attr('data-ctAnnouncementId', response['data']['ct_announcement']['id']);
        }
      })
  }

  save() {
    let id = $("#CtAnnouncementModal .modal-footer button").attr('data-ctAnnouncementId');
    if (id != null) {
      let data = { ct_announcement_id: id }
      $('#CtAnnouncementModal .modal-footer button').attr('disabled','disabled');
      $('#CtAnnouncementModal .modal-footer button').html('loading...');
      axios.post(Routes.read_ct_announcements_path(), null, { params: data })
        .then(response => {
          $('#CtAnnouncementModal').remove();
          $('.modal-backdrop').remove();
          $('body').removeClass('modal-open');
        })
    }
  }
}
